import { KanbanBoard, ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import ActivitiesListItem from '../ActivitiesListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} id="activitiesView" itemLayout={ActivitiesListItem} />
	},
	{
		id: 'kanban',
		title: 'VIEW_ACTIVITIES_TAB_KANBAN',
		content: props => <KanbanBoard id="activitiesKanbanFilters" module="activities" bucket="activities_statuses" />
	}
];

export default tabs;
